import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	footer: {
		gridArea: 'footer',
		position: 'relative',
		zIndex: 200,
		pointerEvents: 'auto',
		minWidth: 0,
		paddingInline: token('space.200'),
		paddingBottom: token('space.200'),
	},
});

export type CardFooterProps = {
	children: React.ReactNode;
	testId?: string;
};

export const CardFooter = ({ children, testId }: CardFooterProps): React.JSX.Element => (
	<Box xcss={styles.footer} testId={testId}>
		{children}
	</Box>
);
